import {ProductionJob} from './production-job';

export function filterProductionJobs(term: string, allJobs: ProductionJob[], locationPredicate: (job: ProductionJob) => boolean): ProductionJob[] {
  const normalizedTerm = term.trim().toLowerCase();

  if (!normalizedTerm) {
    return allJobs.filter(locationPredicate);
  }

  return allJobs
    .filter(item => item.plantName.toLowerCase().includes(normalizedTerm)
      || item.plantCode.toLowerCase().includes(normalizedTerm))
    .filter(locationPredicate);
}
